module.exports = __webpack_public_path__ + "static/media/alternativeInvestments.99a97c91.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tradingPreferences/alternativeInvestments.svg
// module id = 346
// module chunks = 21